/**
 * Search-term transform rules, applied in order to the typed query.
 * Add new rules here as needed.
 */
const SEARCH_TERM_RULES = [
  {
    // re:designed -> redesigned
    transform(term) {
      return term
        .replace(/[^\p{L}\p{N}\s]+/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    },
  },
];

function applySearchQuery(term) {
  let next = term.trim();
  if (!next) return '';

  for (const rule of SEARCH_TERM_RULES) {
    next = rule.transform(next) ?? next;
  }

  return next;
}

class GtcSearchInput extends HTMLElement {
  connectedCallback() {
    this.queryInput = this.querySelector('input[name="q"]');
    this.termInput = this.querySelector('input[type="search"], input:not([type="hidden"])');
    this.form = this.closest('form');

    if (!this.queryInput || !this.termInput) return;

    this.sync = this.sync.bind(this);
    this.termInput.addEventListener('input', this.sync);
    this.termInput.addEventListener('change', this.sync);
    this.form?.addEventListener('submit', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    this.termInput?.removeEventListener('input', this.sync);
    this.termInput?.removeEventListener('change', this.sync);
    this.form?.removeEventListener('submit', this.sync);
  }

  sync() {
    const nextValue = applySearchQuery(this.termInput.value);
    if (this.queryInput.value === nextValue) return;

    this.queryInput.value = nextValue;
    this.queryInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('gtc-search-input')) {
  customElements.define('gtc-search-input', GtcSearchInput);
}
